export const MenuSlug = {
  Footer: 'footer',
  Header: 'header',
  SocialLinks: 'social-links',
  MessengerLinks: 'messenger-links',
  TabbarMessengers: 'tabbar-messengers',
  HeaderNavigation: 'header-navigation',
  MobileMenuTop: 'mobile-menu-top',
  MobileMenuBottom: 'mobile-menu-bottom',
  MyAccountNavigation: 'my-account-navigation',
} as const;

export type MenuSlug = (typeof MenuSlug)[keyof typeof MenuSlug];
